import script from "./InstructionList.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionList.vue?vue&type=script&setup=true&lang=js"

import "./InstructionList.vue?vue&type=style&index=0&id=1b1495b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b1495b8"]])

export default __exports__